/**
 * Pure data helpers for the report. No DOM.
 */

import type { Card, CheckSummary, VerdictCode } from '@eloquor/api-contract';

export function buildSummary(cards: Card[]): CheckSummary {
  const sum: CheckSummary = {
    total: cards.length,
    ok: 0,
    ethicsvio: 0,
    miscut: 0,
    powertagged: 0,
    unclear: 0,
    error: 0,
    unchecked: 0,
  };
  for (const c of cards) sum[c.verdict as VerdictCode] += 1;
  return sum;
}

export function formatPath(card: Card): string {
  return [card.path.pocket, card.path.hat, card.path.block].filter(Boolean).join(' › ');
}

export interface ArgumentGroup {
  key: string;
  label: string;
  cards: Card[];
  summary: string;
  /** Stringified preview of chains, if any (full structure not rendered in PDF for now). */
  chains: string[];
}

export function groupCardsByArgument(cards: Card[]): ArgumentGroup[] {
  const groups = new Map<string, ArgumentGroup>();
  for (const c of cards) {
    const key = `${c.path.pocket ?? ''}|${c.path.hat ?? ''}|${c.path.block ?? ''}`;
    let g = groups.get(key);
    if (!g) {
      g = {
        key,
        label: formatPath(c) || '(unassigned)',
        cards: [],
        summary: c.summary ?? '',
        chains:
          c.chains?.map((ch) =>
            [
              ch.uniqueness.length ? `Uniqueness: ${ch.uniqueness.join('; ')}` : null,
              ch.links.length ? `Links: ${ch.links.join('; ')}` : null,
              ch.internalLinks.length ? `Internal: ${ch.internalLinks.join('; ')}` : null,
              ch.impacts.length ? `Impacts: ${ch.impacts.join('; ')}` : null,
            ]
              .filter(Boolean)
              .join(' / ')
          ) ?? [],
      };
      groups.set(key, g);
    }
    g.cards.push(c);
  }
  return [...groups.values()];
}
